import React, { useState } from "react";
import { setAdminPassword } from "../../api";
import { useLocation } from "react-router-dom";
import "./SetPassword.css";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const token = query.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await setAdminPassword(token, password, confirmPassword);
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response ? error.response.data.error : error.message);
    }
  };

  return (
    <div className="set-password-container">
      <form onSubmit={handleSubmit} className="set-password-form">
        <h2>Set Password</h2>
        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Confirm Password:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="submit-button">
          Set Password
        </button>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default SetPassword;
